import React from 'react';
import UserForm from '../UserForm';

interface TeacherFormProps {
  defaultValues?: any;
}

const PROFESSOR_GROUP = {
  id: 4,
  name: 'Professor',
};

export default function TeacherForm({ defaultValues = {} }: TeacherFormProps) {
  return (
    <UserForm
      defaultValues={defaultValues}
      fixedGroup={PROFESSOR_GROUP}
      returnPage="teachers"
      entityLabel="Professor"
      backLabel="Professores"
      requireInstitutions
    />
  );
}
